import { createFileRoute } from '@tanstack/react-router';
import { ResetPasswordForm } from '@amber-ui/core';

export const Route = createFileRoute('/reset_password')({
  component: ResetPasswordForm,
});
